import { WebRelayActuatorStateEnum } from '@/types/c2/c2.types';
import { Abstract, Mark } from '@/types/commons/commons.types';

export enum EquipmentTypeEnum {
  WEB_RELAY = 'WEB_RELAY',
}

export enum EquipmentStateEnum {}

export interface SensorConfigurationReference {
  id: number;
  sensorAppCode: string;
  sensorSite: string;
  sensorCode: string;
}

export interface CommonEquipmentConfiguration extends Abstract {
  id: number;
  uniqueKey: string;
  appCode: string;
  site: string;
  active: boolean;
  code: string;
  name: string;
  host: string;
  states: EquipmentStateEnum[];
  sensorReferences: SensorConfigurationReference[];
  marks: Mark[];
}

export enum WebRelayTypeEnum {
  WR_10 = 'WR_10',
  WR_X400 = 'WR_X400',
  WR_X_WR = 'WR_X_WR',
}

export interface WebRelayConfiguration extends CommonEquipmentConfiguration {
  type: EquipmentTypeEnum.WEB_RELAY;
  webRelayType: WebRelayTypeEnum;
  actuator: number | null;
}

export enum EquipmentConnectionStatusEnum {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export type EquipmentConfiguration = WebRelayConfiguration;

export interface CommonEquipmentStatus<T extends EquipmentConfiguration> {
  configuration: T;
  connectionStatus: EquipmentConnectionStatusEnum;
}

export interface WebRelayStatus extends CommonEquipmentStatus<WebRelayConfiguration> {
  type: EquipmentTypeEnum.WEB_RELAY;
  actuatorState: WebRelayActuatorStateEnum;
}

export type EquipmentStatus = WebRelayStatus;
